(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CreateUserAccountController', CreateUserAccountController);


    CreateUserAccountController.$inject = ['$rootScope', '__config', '$translate', '$timeout', 'Auth', 'LoginService', 'PersonInfo', '$state', '$element', 'OrderBagCustom', 'User','UserCustom', '$localStorage', 'TrackingService', 'Marketing'];

    function CreateUserAccountController($rootScope, __config, $translate, $timeout, Auth, LoginService, PersonInfo, $state, $element, OrderBagCustom, User,UserCustom, $localStorage, TrackingService, Marketing) {
        var vm = this;
        vm.isSaving = false;
        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;
        vm.activatedSuccess = null;
        vm.activateUser = activateUser;
        vm.submited = submited;
        vm.formMode = 'REGISTER';
        vm.errorPhoneNumberExists = null;
        vm.regenerateActivationKey = regenerateActivationKey;
        vm.activatedSuccess = null;
        vm.regenerateSuccess = null;
        vm.showError = false;
        vm.findImageClass = findImageClass;
        vm.__config = __config;
        vm.questions = {
            findUsOtherWayDesc: "",
            howDidYouFindUs: "",
        }
        vm.howDidYouFindUsOptions = [
            {
                name: 'جستجو در گوگل',
                value: 'GOOGLE_SEARCH'
            },
             {
                name: 'شبکه های اجتماعی',
                value: 'SOCIAL_NETWORKS'
            },
             {
                name: 'پیامک',
                value: 'SMS'
            },
            {
                name: 'دوستان',
                value: 'FRIENDS'
            },
            {
                name: 'chatgpt ',
                value: 'CHATGPT'
            },
            {
                name: 'سایر',
                value: 'OTHER'
            },
        ]

        vm.referralCode = null;
        // $rootScope.$broadcast('hideNavBar');
        checkUserIsLoggedIn()
        initTracking()
        if ($state && $state.params && $state.params.referralCode) {
            vm.referralCode = $state.params.referralCode;
        }

        $timeout(function () {
            angular.element('#login').focus();
        });

        function submited(formName) {
            vm.showError = false;
            // not register yet
            if (vm.formMode == 'REGISTER') {
                if (formName.$invalid) {
                    vm.showError = true;
                    return;
                }
                register();
            }
            if (vm.formMode == 'ACTIVEUSER') {
                activateUser();
            }

        }

        function register() {
            vm.registerAccount.langKey = $translate.use();
            vm.doNotMatch = null;
            vm.error = null;
            vm.errorUserExists = null;
            vm.errorEmailExists = null;
            vm.errorPhoneNumberExists = null;

            vm.registerAccount.login = vm.registerAccount.phoneNumber;

            vm.isSaving = true;
            Auth.sendActivationCode(vm.registerAccount.login).get(function () {
                vm.isSaving = false;
                vm.success = 'OK';
                vm.formMode = 'ACTIVEUSER';
                vm.resetTimer();

            }, function (response) {

                if (response.status === 400 && response.data === 'login_already_in_use') {
                    vm.errorPhoneNumberExists = 'ERROR';
                } else if (response.status === 400 && response.data === 'e-mail_address_already_in_use') {
                    vm.errorEmailExists = 'ERROR';
                } else if (response.status === 400 && response.data === 'PhoneNumber_already_in_use') {
                    vm.errorPhoneNumberExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
                vm.isSaving = false;
            })
            //Auth.createAccount(vm.registerAccount).then(function () {
            //    //
            //    vm.success = 'OK';
            //    vm.formMode = 'ACTIVEUSER';
            //    vm.resetTimer();
            //
            //}).catch(function (response) {
            //    vm.success = null;
            //    if (response.status === 400 && response.data === 'login_already_in_use') {
            //        vm.errorPhoneNumberExists = 'ERROR';
            //    } else if (response.status === 400 && response.data === 'e-mail_address_already_in_use') {
            //        vm.errorEmailExists = 'ERROR';
            //    } else if (response.status === 400 && response.data === 'PhoneNumber_already_in_use') {
            //        vm.errorPhoneNumberExists = 'ERROR';
            //    } else {
            //        vm.error = 'ERROR';
            //    }
            //
            //
            //});

        }

        vm.counter = 60;
        var stopped;
        vm.onCounterEnded = onCounterEnded;
        vm.resetTimer = resetTimer;
        vm.counterIsEnded = false;
        vm.countdown = function () {
            stopped = $timeout(function () {

                vm.counter--;
                if (vm.counter == 0) {
                    vm.onCounterEnded();
                } else
                    vm.countdown();
            }, 1000);
        };
        vm.stop = function () {
            $timeout.cancel(stopped);

        };

        function resetTimer() {
            vm.counter = 60;
            vm.counterIsEnded = false;
            vm.countdown();
        }

        function onCounterEnded() {
            vm.counterIsEnded = true;
        }


        function activateUser() {

            // console.log('active user S1');
            OrderBagCustom.logIntoServer().save('PLLOG active user S1');
            //
            if (vm.key != null) {
                vm.isSaving = true;
                vm.registerAccount.activationCode = vm.key;

                // console.log('active user S2 : ' + vm.key);
                OrderBagCustom.logIntoServer().save('PLLOG active user S2 ' + vm.key);

                if (vm.referralCode)
                    vm.registerAccount.referralCode = vm.referralCode;

                // console.log('active user S3');
                OrderBagCustom.logIntoServer().save('PLLOG active user S3');


                Auth.createAccount(vm.registerAccount).then(function () {
                    OrderBagCustom.logIntoServer().save('PLLOG active user S4');
                    Auth.activateAccount(vm.registerAccount.login, vm.key).then(function () {

                        OrderBagCustom.logIntoServer().save('PLLOG active user S5');

                        Auth.login({
                            username: vm.registerAccount.login,
                            password: vm.registerAccount.password,
                            rememberMe: false,
                            captchaCode: null
                        }).then(function () {
                            UserCustom.setUserInsight().save(vm.questions)
                            vm.isSaving = false;
                            vm.activateError = null;
                            vm.activatedSuccess = 'OK';
                            // initTracking();
                            if($localStorage.trackingData) {
                                marketingAttribution($localStorage.trackingData);
                            }
                            addGTagData();
                            $state.go('initSetupWizardV2');

                        })
                    }).catch(function () {
                        //

                        OrderBagCustom.logIntoServer().save('PLLOG active user Error 1');
                        vm.isSaving = false;
                        vm.activatedSuccess = null;
                        vm.activateError = 'ERROR';
                    });

                }).catch(function (response) {
                    OrderBagCustom.logIntoServer().save('PLLOG active user Error 2');
                    vm.isSaving = false;
                    vm.success = null;
                    vm.isSaving = false;
                    vm.activatedSuccess = null;
                    vm.activateError = 'ERROR';
                    if (response.status === 400 && response.data === 'login_already_in_use') {
                        vm.errorPhoneNumberExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'e-mail_address_already_in_use') {
                        vm.errorEmailExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'PhoneNumber_already_in_use') {
                        vm.errorPhoneNumberExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }


                });

            } else {
                //
                vm.activatedSuccess = null;
                vm.activateError = 'ERROR';
            }

        }

        function regenerateActivationKey() {
            vm.register();
            //
            //Auth.regenerateActivationKey(vm.registerAccount.login)
            //    .then(function(){
            //        //
            //    vm.regenerateSuccess ='OK';
            //    vm.regenerateError =null;
            //        vm.resetTimer();
            //}).catch(function () {
            //    //
            //    vm.regenerateSuccess = null;
            //    vm.regenerateError = 'ERROR';
            //});
        }

        function findImageClass() {
            if (vm.__config.appMode == 'reserve')
                return 'left-register-image';
            if (vm.__config.appMode == 'event')
                return 'left-register-image-wd';
        }

        function addGTagData() {
            //user  registered
            try {
                gtag('event', 'user_start_register', {
                    "items": [
                        {
                            "id": "PL101",
                            "name": "User Activated Account",
                            "list_name": "",
                            "brand": "Planovin",
                            "category": "UNKNOWN",
                            "price": '0'
                        }
                    ]
                });
            } catch (err) {
                console.log(err);
            }
        }

        function checkUserIsLoggedIn() {
            if($localStorage.authenticationToken) {
                $state.go('supplierPanel-v2.dashboard')
            }
        }
        function initTracking() {
            TrackingService.collect().then(function(trackingData) {
                if(trackingData.gclId || trackingData._gl) {
                    $localStorage.trackingData = trackingData;
                }
            }).catch(function (error) {
                console.error("TrackingService.collect failed:", error);
            });
        }
        function marketingAttribution(trackingData) {
            Marketing.marketingAttribution().save(trackingData, function(res) {
                if(res.leadId) {
                    var newData = trackingData;
                    newData['leadId'] = res.leadId;
                    UserCustom.userAttribution().save(newData, onSuccessUserAttribution, onErrorUserAttribution);
                }
            }, onErrorAttribution)
            function onSuccessUserAttribution() {
                delete $localStorage.trackingData;
            }
            function onErrorUserAttribution() {
                delete $localStorage.trackingData;
            }
                
        }
        function onErrorAttribution(error) {
            console.log(error);
        }
    }
})();
